export default __webpack_public_path__ + "static/media/Sofia-Pro-Medium.5b20abb3.otf";